import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Paper from 'material-ui/Paper';
import numeral from 'numeral';

import Fetcher from '../../util/fetcher';
import LoaderOverlay from '../LoaderOverlay';
import StepProps from '../../constants/StepProps';

const style = {
  flexBox: {
    display: 'flex',
    flexWrap: 'wrap',
  },
}

class PoiResults extends Component {
  static contextTypes = {
    dataset: PropTypes.string.isRequired,
    firebaseToken: PropTypes.string.isRequired,
    history: PropTypes.object.isRequired,
  };

  static propTypes = StepProps;

  state = {
    loading: true,
    stats: {
      // inputs: '',
      mapped: '',
      devices: '',
      records: '',
    },
  }

  requestSent = false;

  componentDidMount() {
    this.fetchStatsIfNeeded();
  }

  componentDidUpdate(prevProps, prevState, prevContext) {
    this.fetchStatsIfNeeded();
  }

  fetchStatsIfNeeded() {
    const { hash } = this.props;
    if (!this.requestSent && this.context.firebaseToken) {
      this.requestSent = true;
      Fetcher.init(this.context.firebaseToken)
        .poiFetchStats(hash, this.context.dataset)
        .then(this.handleFetchComplete)
        .catch(this.handleFetchFail);
      // this.handleFetchComplete({data:{
      //   mapped: 24900,
      //   devices: 1356000,
      //   records: 1308900000,
      // }});
    }
  }

  handleFetchComplete = ({data:stats}) => {
    const {mapped, devices, records} = stats;
    this.setState({
      loading:false,
      stats: {
        mapped,
        devices,
        records,
      }
    });
  }

  handleFetchFail = () => {
    // TODO: give client feedback on fail
    this.setState({loading:false});
  }

  render() {
    return (
      <div>
        <LoaderOverlay visible={this.state.loading} />
        <h2>POI matching completed</h2>
        <Paper zDepth={1} className="ContentSpacing">
          <p>The results of the POI audience matching are displayed below. If you are pleased with the results, click next to proceed to the download step.</p>
          <div style={style.flexBox}>
            {/* <StatsBox>
              <StatsBig>{this.state.stats.inputs}</StatsBig>
              <StatsSubtitle>Source locations</StatsSubtitle>
            </StatsBox> */}
            <StatsBox>
              <StatsBig>{this.state.stats.mapped}</StatsBig>
              <StatsSubtitle>Locations</StatsSubtitle>
            </StatsBox>
            <StatsBox>
              <StatsBig>{this.state.stats.devices}</StatsBig>
              <StatsSubtitle>Devices matched</StatsSubtitle>
            </StatsBox>
            <StatsBox>
              <StatsBig>{this.state.stats.records}</StatsBig>
              <StatsSubtitle>Records matched</StatsSubtitle>
            </StatsBox>
          </div>
        </Paper>
      </div>
    )
  }
}

export default PoiResults

const StatsBox = ({ children }) => {
  const style = {
    flex: '1 0 0',
    height: 120,
    margin: 10,
    padding: 10,
    textAlign: 'center',
    display: 'inline-block',
  }
  return (
    <Paper style={style}>{children}</Paper>
  
  )
}
const StatsBig = ({ children, autoFormat = true }) => {
  const style = {
    whiteSpace: 'nowrap',
    textAlign: 'center',
    padding: 0,
    margin: 0,
    fontWeight: 400,
    color: 'black',
    maxWidth: '100%',
  }
  let origVal = children;
  if (autoFormat && !isNaN(children)) {
    let formatStr = (children > 1000000) ? '(0.[0]a)' : '(0a)';
    children = numeral(children).format(formatStr).toUpperCase();
  }
  return (
    <h2 title={origVal} style={style}>{children}</h2>
  )
}

const StatsSubtitle = ({ children }) => {
  const style = {
    textAlign: 'center',
    padding: 0,
    margin: 0,
    fontWeight: 500,
    fontSize: '12px',
    color: '#999',
    textTransform: 'uppercase',
  }
  return (
    <span style={style}>{children}</span>
  )
}



// WEBPACK FOOTER //
// ./src/components/PoiStepResults/index.jsx